module.exports = __webpack_public_path__ + "img/main_warikann.532a6f68.png";